/*
	events
	usage:

	return:
*/

/*
//Usage of the events-module
var fetch_child_4_click_same,
	fetch_child_4_click_below,
	html = '';
html += '<div id="parent" class="fkn_parent" name="ADD LISTENER TO THIS" val="0">';
html += ' <div id="child_1" class="fkn_child_1" val="1">';
html += ' 	<div id="child_2" class="fkn_child_2" val="2">';
html += ' 		<div id="child_3" class="fkn_child_3" val="3">';
html += ' 			<div id="child_4" class="fkn_child_4" val="4" name="CATCH THIS ELEMENT WITH THE FILTER CLASS NAME">';
html += '				<p id="content_A" class="fkn_content_A" val="5" name="CLICK ON THIS ELEMENT"></p>';
html += '				<p id="content_B" class="fkn_content_A" val="6" name="OR CLICK ON THIS ELEMENT">';
html += '					<span id="inner_content" class="fkn_inner_content" val="7" name="OR CLICK ON THIS ELEMENT"></span>';
html += '				</p>';
html += '				<p id="content_C" name="OR CLICK ON THIS ELEMENT" val="8"></p>';
html += '				<p id="content_D" name="OR CLICK ON THIS ELEMENT" val="9"></p>';
html += '			</div>';
html += '		</div>';
html += '	</div>';
html += '</div>';

document.querySelector('body').innerHTML += html;*/

// This custom eventhandling system allows attachment of an eventlistener to a common parent, and
// at the same time fetch any of its children. For example click inside a containers child elements
// is registered higher up in the hierarchy, but still fetching the child element. If the last argument
// is set to 'false' in handle.(eventobject,'.filterclass',callback, false|true) only the precise click on the child element is registered.

/* fetch_child_4_click_same = function (e) {
	var cb = function (p) {
		// p.e gets the event object
		p.e.stopPropagation();
		var elm = p.elm,
			id = (elm.getAttribute('id'));
	};
	// This handler function runs the callback only if the .fkn_child_4 element is clicked
	core.handle(e, '.fkn_child_4', cb, false);
};

fetch_child_4_click_below = function (e) {
	var cb = function (p) {
		//p.e gets the event object
		p.e.stopPropagation();
		var elm = p.elm,
			id = (elm.getAttribute('id'));
	};

	//If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked
	core.handle(e, '.fkn_child_4', cb, true);
};


// Listener is added to the parent element, the handler-function determines the result
core.addListener(document.querySelector('#parent'), 'click', fetch_child_4_click_same);
core.addListener(document.querySelector('#parent'), 'click', fetch_child_4_click_below);


// Click is invoked on the innermost element

setTimeout(function () {
	$('#inner_content').click();
}, 600);
*/

function containsWord(string, word) {
	// string can be:  js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input
	// word can be: js-payment__input-cvc-creditcard
	// word is then part of string
	// if word is 'js-payment' then word is not part of string
	const hasValues = Boolean(string && word);
	let anyWordMatches = false;
	if (hasValues) {
		const wordsInString = string.split(/\s/); // separated on space-character
		wordsInString.forEach((w) => {
			if (w === word) {
				anyWordMatches = true;
			}
		});
	}
	return anyWordMatches;
}

function checkParentForFilterHit(element, filter, addFilter) {
	let node = element;
	let additionalFilterHit = false;
	let parentNode = node.parentNode;
	let className = element.className;
	let wrapFilterHit = false;
	const wrapFilter = 'adcont';
	let seq = 0;
	let parentTargetHit = false;
	while (parentNode !== null && !(seq > 15 || wrapFilterHit || parentTargetHit)) {
		node = parentNode;
		className = parentNode.className;
		parentTargetHit = containsWord(className, filter);
		wrapFilterHit = containsWord(className, wrapFilter);
		if (!additionalFilterHit) {
			additionalFilterHit = containsWord(className, addFilter);
		}
		seq += 1;
		parentNode = node.parentNode;
	}
	return {
		filterHit: parentTargetHit,
		targetElem: node,
		className
	};
}

function handle(e, classSelectorFilter, sendFkn, checkParent) {
	const handler = (function theHandler() {
		const evObject = e || window.event;
		let targetElem = evObject.target || evObject.srcElement;
		let filterHit = false;
		let className = targetElem.className;
		const data = evObject.detail;
		let checkParentObj;
		const filterClassName = classSelectorFilter.slice(1);
		filterHit = containsWord(className, filterClassName);
		if (!filterHit && checkParent) {
			checkParentObj = checkParentForFilterHit(targetElem, filterClassName);
			filterHit = checkParentObj.filterHit;
			className = checkParentObj.className;
			targetElem = checkParentObj.targetElem;
		}
		if (filterHit && sendFkn) {
			sendFkn({
				elm: targetElem,
				data,
				e: evObject
			});
		}
		return {
			getEventObj() {
				return {
					className,
					data,
					filterHit,
					filter: filterClassName
				};
			}
		};
	}());
	return handler;
}

function startListening(parentElement, eType, eventHandler) {
	let eventType = eType;
	try {
		if (parentElement.addEventListener) {
			parentElement.addEventListener(eventType, eventHandler, false);
		} else if (parentElement.attachEvent) {
			eventType = `on${eventType}`;
			parentElement.attachEvent(eventType, eventHandler);
		} else {
			parentElement[`on${eventType}`] = eventHandler;
		}
	} catch (e) {
		console.error(`events:${e}`);
		if (console.trace) {
			console.trace();
		}
	}
}

function removeListenerIfElementExist(parentElm, eventType, eventHandler) {
	if (parentElm && parentElm.removeEventListener) {
		parentElm.removeEventListener(eventType, eventHandler);
	}
}

export default {
	add(parentElm, eventType, eventHandler) {
		startListening(parentElm, eventType, eventHandler);
	},
	handle(event, classSelectorFilter, sendFkn, checkParentFilterHit) {
		return handle(event, classSelectorFilter, sendFkn, checkParentFilterHit);
	},
	remove(parentElm, eventType, eventHandler) {
		removeListenerIfElementExist(parentElm, eventType, eventHandler);
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/events.js